import consumer from '../channels/consumer'

export function createActionCableSubscription(channelName, channelParams = {}, onReceived = null) {
  const subscription = consumer.subscriptions.create(
    { channel: channelName, ...channelParams },
    {
      received(payload) {
        if (onReceived)
          onReceived(payload)
      }
    }
  )
  return subscription
}
